import { getMobileInfoTooltip } from "features/contracting/sections/contractingForms/customerDataForm/customerDataFormHelper";
import PageCard from "features/shared/components/card/PageCard";
import FormGroup from "features/shared/forms/components/FormGroup";
import FormGroupTooltip from "features/shared/forms/components/formGroup/FormGroupTooltip";
import PhoneInput from "features/shared/forms/components/phoneInput/PhoneInput";
import { bindMobilePrefix } from "features/shared/forms/components/phoneInput/phoneInputConfig";
import {
  BindFieldFunction,
  FormErrors,
} from "features/shared/forms/hooks/useForm";
import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
  bindField: BindFieldFunction;
  errors: FormErrors;
  mobilePhonePrefixRef: React.RefObject<HTMLSelectElement>;
  showPhoneInpunt?: boolean;
  disabled?: boolean;
  enableMobileTooltip?: boolean;
};

const CustomerContactDataSubForm = ({
  bindField,
  errors,
  mobilePhonePrefixRef,
  showPhoneInpunt,
  disabled,
  enableMobileTooltip
}: Props) => {
  // translations
  const tLabels = useTranslation("contracting\\contracting").t;

  // sub-renders
  const renderPhoneInput = () => {
    if (showPhoneInpunt) {
      return (
        <div className="col-sm-6 px-2">
          <FormGroup
            labelText={tLabels("customerContactDataSubForm.phoneNumber.label")}
            inputId="phoneNumber"
            validationError={errors["phoneNumber"]}
          >
            <input
              id="phoneNumber"
              className="form-control"
              placeholder={tLabels("customerContactDataSubForm.phoneNumber.placeholder")}
              {...bindField("phoneNumber")}
              disabled={disabled}
            />
          </FormGroup>
        </div>
      );
    }
  };

  // render
  return (
    <PageCard
      title={tLabels("customerContactDataSubForm.cardTitle")}
      bodyClassName="pt-4 px-4"
      cardClassName="mb-4"
    >
      <div className="row no-gutters mx-n2">
        <div className="col-sm-6 px-2">
          <FormGroup
            labelText={tLabels("customerContactDataSubForm.email.label")}
            inputId="email"
            validationError={errors["email"]}
          >
            <input
              id="email"
              className="form-control"
              placeholder={tLabels("customerContactDataSubForm.email.placeholder")}
              {...bindField("email")}
              disabled={disabled}
            />
          </FormGroup>
        </div>
        <div className="col-sm-6 px-2">
          <FormGroup
            labelText={tLabels("customerContactDataSubForm.mobileNumber.label")}
            inputId="mobileNumber"
            validationError={errors["mobileNumber"]}
            tooltip={getMobileInfoTooltip(tLabels, enableMobileTooltip)}
          >
            <PhoneInput
              ref={mobilePhonePrefixRef}
              id="mobileNumber"
              {...bindField("mobileNumber")}
              {...bindMobilePrefix(bindField)}
              placelhoder={tLabels("customerContactDataSubForm.mobileNumber.placeholder")}
              disabled={disabled}
            />
          </FormGroup>
        </div>
        {renderPhoneInput()}
        <div className="col-sm-6 px-2">
          <FormGroup
            labelText={tLabels("customerContactDataSubForm.dataBox.label")}
            inputId="dataBox"
            validationError={errors["dataBox"]}
          >
            <input
              id="dataBox"
              className="form-control"
              placeholder={tLabels("customerContactDataSubForm.dataBox.placeholder")}
              {...bindField("dataBox", true)}
              disabled={disabled}
            />
          </FormGroup>
        </div>
      </div>
    </PageCard>
  );
};

export default CustomerContactDataSubForm;
